<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-textarea
                                        outlined
                                        name="input-7-4"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.webHook')" 
                                        v-model="data.webhook"
                                    ></v-textarea>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose">
                            {{$vuetify.lang.t('$vuetify.portalManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleSave" :loading="loading">
                            {{$vuetify.lang.t('$vuetify.portalManage.save')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.portalManage.ac.webhookBtn'),

            loading: false,

            dialog: false,

            data: {
                webhook: ''
            }
            
        }
    },

    methods: {

        handleOpen (item) {
            this.data = this.newObject(item);
            this.data.webhook = this.initWebhook(this.data.webhook);
            this.dialog = true;
        },

        initWebhook (value) {
            if (value === null) return null;
            var temp = value.split(",");
            return temp.join("\n");
        },

        handleClose () {
            this.dialog = false;
            this.$refs.form.reset();
        },

        handleSave () {
            if (this.$refs.form.validate()) {
                this.loading = true;
                var temp = this.data.webhook.split("\n");
                this.data.webhook = temp.join(",");
                this.$http.post(api.default.portal.acSetWebhookUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        },

        newObject (item) {
            var data = JSON.stringify(item);
            return JSON.parse(data)
        }

    }
}
</script>